export class MenuUtil {
    static close() {
        if (window['navigationMobileMenuReset']) {
            window.navigationMobileMenuReset();
        }
    }
}
